import React, { memo } from 'react';
import { Icon, Stack, Typography, Divider, Chip } from 'investira.react.components';
import { formats } from 'investira.sdk';

const AvaliacaoOutputHeader = memo(props => {
  const { created = new Date(), gestor = {} } = props;
  return (
    <Stack
      direction="row"
      gap={1.5}
      alignItems="center"
      sx={{
        flex: 1,
        minWidth: 0
      }}>
      <Icon iconName="calendar" color="textSecondary" size={16} />
      <Typography variant="caption" color="textSecondary">
        {created && formats.formatDateCustom(created, 'DD/MM/YYYY')}
      </Typography>
      <Divider orientation="vertical" flexItem />
      <Typography variant="caption" color="textSecondary">
        {gestor.pessoa_fantasia || 'Alpha Asset Management Ltda.'}
      </Typography>
      <Divider orientation="vertical" flexItem />
      <Typography variant="caption" color="textSecondary">
        Avaliador: Fulano Silva
      </Typography>
      <Divider orientation="vertical" flexItem />
      <Typography variant="caption" color="textSecondary">
        Cargo/Posição: Gerente de Risco
      </Typography>
    </Stack>
  );
});

export default AvaliacaoOutputHeader;
